<template>
  <div class="zoom">
	<div @click="zoomIn()" class="tooltip is-tooltip-left" :data-tooltip="tooltips.zoomin"><plus-icon/></div>
	<div @click="zoomOut()" class="tooltip is-tooltip-left" :data-tooltip="tooltips.zoomout"><moins-icon/></div>
  </div>
</template>

<script>

import PlusIcon from './icons/zoom_in.svg';
import MoinsIcon from './icons/zoom_out.svg';
import tooltips from '@texts/tooltips.json'

export default {
	name: 'Zoom',
	components: {
		PlusIcon,
		MoinsIcon,
	},
	data() {
		return {
			tooltips: tooltips,
		}
	},
	methods: {
		zoomIn() {
			this.$emit('zoom', 'in')
		},
		zoomOut() {
			this.$emit('zoom', 'out')
		}
	}
}
</script>


<style scoped lang="scss">

.zoom {
	@extend %base-btn;

	flex-direction: column;
	align-items: center;
	height: 69px;

	> * {
		justify-content: center;
		width: 100%;
		height: 50%;
		display: flex;

		&:first-child {
			border-bottom: 1px solid lighten($noir, 82%);
		}
	}

	svg {
		max-width: 14px;
		fill: $noir;
		//transform: scale(.4);
	}


}

</style>
